<template>
    <div class="div side-right" :class="{ open: open }">
        <transition name="fade">
            <!-- <section-login></section-login> -->
        </transition>
        <transition name="fade">
            <!-- <section-user>
                <template v-slot:panel-section-user>
                    <slot name="panel-section-user"></slot>
                </template>
            </section-user> -->
        </transition>
        <transition name="fade">
            <slot name="others-panels"></slot>
        </transition>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            section: '',
            open: false
        }
    },
    mounted() {
        if ($('header').outerHeight() != $('.side-right').css('top')) {
            $('.side-right').css('top', $('header').outerHeight())
        }

        $(document).on('click', e => {
            if ($(e.target).closest('.side-right').length == 0 && $(e.target).closest('header .nav-menu').length == 0) {
                this.open = false
            }
        })

        $('header .nav-menu li[data-section]').click(e => {
            let newSection = $(e.currentTarget).data('section')

            if (this.open && newSection == this.section) {
                this.open = false
            } else if (newSection != this.sectio) {
                this.open = true
            }

            $('.panel').hide()
            $('.' + newSection).show()

            this.section = newSection
        })
    }
}
</script>

<style scoped lang="scss">
.side-right {
    width: 320px;
    background-color: #fff;
    z-index: 1061;
    position: fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    font-size: 0.8em;
    overflow: auto;
    -webkit-box-shadow: -2px 8px 9px -5px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -2px 8px 9px -5px rgba(0, 0, 0, 0.75);
    box-shadow: -2px 8px 9px -5px rgba(0, 0, 0, 0.75);
    transform: translateX(140%);
    transition-timing-function: ease-in;
    transition: 0.2s;

    &.open {
        transition: 0.25s;
        transition-timing-function: ease-out;
        transform: translateX(0);
    }

    .panel {
        position: absolute;
        padding: 10px;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>